import { normalizeCode } from './utils';
const SCREEN_QR = /^[A-Z0-9]{3}[-\s]?[A-Z0-9]{3}$/i;
// The TV QR holds only the 6-char code; a code of another server simply fails to pair (404)
export const parseScreenQr = (text) => {
    const trimmed = text.trim();
    return SCREEN_QR.test(trimmed) ? normalizeCode(trimmed) : null;
};
